$( document ).ready(function() {

    //home change header color on scroll
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $(".page-template-page-home .site-header").addClass('header--white').removeClass('header--home');
        } else {
            $(".page-template-page-home .site-header").removeClass('header--white').addClass('header--home');
        }
    })


        $('.burger--menu--toggle').click(function() {
        $('.burger--menu--toggle').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass( "header--open" )) {
            //burger toggle animation
            $('.burger--menu--toggle').addClass("burger--closed");
            $('body').addClass('nav--open');
            $('.site-header-scroll').removeClass('nav-up').addClass('nav-down');


            //open menu
            $('.header-mobile-content').addClass("header--open").removeClass("header--closed");
            $('html, body').css({
                overflow: 'hidden',
            });
            $('#primary').css({
                'pointer-events': 'none',
            });
        } else {
            //burger toggle animation
            $('.burger--menu--toggle').removeClass("burger--closed");
            $('body').removeClass('nav--open');


            //close menu
            $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
            $('html, body').css({
                overflow: 'auto',
            });
            $('#primary').css({
                'pointer-events': 'all',
            });

            // close submenus
            $('#header-menu-left .slide-submenu .sub-menu').removeClass('menu--slide--in');
            $('#header-menu-left .acc-submenu > .sub-menu').slideUp('slow').removeClass('rotate');
        }

        setTimeout(function() {
            // enable click after 1 second
            $('.burger--menu--toggle').prop('disabled', false);
        }, 500); // .5 second delay

    });



    // //
    // //close menu if click on page
    // //
    $(document).mouseup(function(e){
        var container = $(".header--open, .header--burger, #ais-wrapper");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.header-mobile-content').removeClass("header--open");
          $('.burger--menu--toggle').removeClass('burger--closed');
          $('html, body').css({
            overflow: 'auto',
          });
          $('#primary').css({
              'pointer-events': 'all',
          });

          // close submenus
          $('#header-menu-left .slide-submenu .sub-menu').removeClass('menu--slide--in');
          $('#header-menu-left .acc-submenu > .sub-menu').slideUp('slow').removeClass('rotate');
        }
    });




    //hide navbar on scroll
    $(function(){
    	 var lastScrollTop = 0, delta = 5;
    	 $(window).scroll(function(){
    		 var nowScrollTop = $(this).scrollTop();
             var scroll = $(window).scrollTop();

    		 if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
    		 	if (nowScrollTop > lastScrollTop){
    		 		// ACTION ON
    		 		// SCROLLING DOWN
                    if (scroll >= 600) {
                        $('.site-header-scroll').removeClass('nav-down').addClass('nav-up');
                    }
    		 	} else {
    		 		// ACTION ON
    		 		// SCROLLING UP
                    $('.site-header-scroll').removeClass('nav-up').addClass('nav-down');
    			}
    		 lastScrollTop = nowScrollTop;
    		 }
    	 });
     });


     $('#header-menu .menu-item-has-children').each(function() {
         $(this).children('a').addClass('dropdown-link');
     });
     $('.dropdown-link').each(function(){
         $(this).click(function(e) {
             e.preventDefault();

             $(".dropdown-link").next().not($(this).next()).removeClass('dropdown');
             if ($(this).next().hasClass('dropdown')) {
                 $(this).next().removeClass('dropdown');
             } else {
                 $(this).next().addClass('dropdown');
             }
         });
     })


     $('#header-menu-left .menu-item-has-children').each(function() {
         if ($(this).hasClass('slide-submenu')) {
            var title = $(this).find('a').attr('title');
            if(!title || title == 'undefined') title = $(this).find('a:first').text();
            $(this).find('> .sub-menu').prepend('<span class="menu--link--back" id="linkBack">Zurück</span><div class="navbar--submenu--title">'+ title +'</div>');
         } else {
             $(this).addClass('acc-submenu');
         }
     });


     $('#header-menu-left .menu-item-has-children').each(function() {

         if ($(this).hasClass('slide-submenu')) {
            $(this).children('a').click(function(e) {
                // console.log('submenu click');
                e.preventDefault();
                $(this).next().addClass('menu--slide--in');
            });

            //close submenu
            $(this).find('.menu--link--back').click(function() {
                $(this).parent().removeClass('menu--slide--in');
            });

         } else {

             $(this).children('a').click(function(e) {
                 // console.log("test");
                 e.preventDefault();
                 $(this).toggleClass('rotate');
                 $(this).next().toggleClass('acc--menu--open');
                 $(this).next().slideToggle('slow');
             });
         }
     })






     function buttonHeightModal() {
         let heighBtn = $('.ais-SearchBox-submit').height();
         $('.ais-SearchBox-submit').width(heighBtn);
         $('.ais-SearchBox-reset').width(heighBtn);
     }

     $( window ).resize(function() {
         buttonHeightModal();
    });

    $('.open--modal').click(function(e){
        e.preventDefault();
        setTimeout(buttonHeightModal, 5)
    })

if($('body').hasClass('tax_landolt_primary') || $('body').hasClass('single-landolt')) {
  setMenu('landolt');
}
else if($('body').hasClass('tax_jm_primary') || $('body').hasClass('single-jms')) {
  setMenu('jms');
}
else if($('body').hasClass('tax_risi_primary') || $('body').hasClass('single-risi')) {
  setMenu('risi');
}
else if($('body').hasClass('tax_beton_primary') || $('body').hasClass('single-beton')) {
  setMenu('beton');
}
else if($('body').hasClass('tax_rueegg_primary') || $('body').hasClass('single-rueegg')) {
  setMenu('rueegg');
}

function setMenu(firma) {
  $('#menu-item-1430 a').attr('href','/'+firma+'/jobs');
  $('#menu-item-80 a').attr('href','/'+firma+'/kontakt');
  $('#menu-item-336 a').attr('href','/'+firma+'/kontakt');
  $('.burger--menu--toggle').click(function() {
    $('li.menu-item.firmen').addClass('current-menu-ancestor');
    $('li.menu-item.firmen > ul.sub-menu').addClass('acc--menu--open').show();
    $('li.menu-'+firma+' ul.sub-menu').addClass('menu--slide--in');
  })
}









$('.show--more--slide').click(function(e){
    e.preventDefault();

    $(this).children().toggleClass('hidden');
    $(this).prev().slideToggle();

})

});





$(document).ready(function(){
    $('.print--site').on('click',function(){
        print();
    });
})
